export const ANGLE_MAP = {
    t:   0,
    r:  90,
    b: 180,
    l: 270,
    // h:   0,
    // v:  90,
};

export function getNextRotation(currentRotation, rotationStates = ['t','r','b','l']) {
    const idx = rotationStates.indexOf(currentRotation);
    return idx === -1
        ? rotationStates[0]
        : rotationStates[(idx + 1) % rotationStates.length];
}

export function getOccupiedCells(row, col, widthCells, heightCells, rotation) {
    let w = widthCells
    let h = heightCells

    if (rotation === 'r' || rotation === 'l') {
        w = heightCells
        h = widthCells
    }

    const cells = []
    for (let dr = 0; dr < h; dr++) {
        for (let dc = 0; dc < w; dc++) {
            cells.push({ row: row + dr, col: col + dc })
        }
    }
    return cells
}